import { render, staticRenderFns } from "./SetupOperation.vue?vue&type=template&id=e2447cb2&scoped=true&"
import script from "./SetupOperation.vue?vue&type=script&lang=js&"
export * from "./SetupOperation.vue?vue&type=script&lang=js&"
import style0 from "./SetupOperation.vue?vue&type=style&index=0&id=e2447cb2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2447cb2",
  null
  
)

export default component.exports